
import React, { useState, useEffect } from 'react';
import { useAuth } from '../../Components/AuthContext/AuthContext'
import { get, post } from '../../Services/api';
import './shopping_list.css';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TextField, Radio, RadioGroup, InputLabel, MenuItem, Select, FormGroup, FormControlLabel, Checkbox, FormControl, easing } from '@mui/material';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
function ShoppingList() {
    const [startDate, setStartDate] = useState(dayjs());
    const [endDate, setEndDate] = useState(dayjs().add(7, 'day'));
    const [shoppingList, setShoppingList] = useState([]);
    const [viewMode, setViewMode] = useState('ingredient_based'); // 'full' or 'meal-based'
    const [selectedMeal, setSelectedMeal] = useState('All Meals')
    const [meals_list, setmealList] = useState([])

    const [isFilterVisible, setIsFilterVisible] = useState(false);
    const [isButtonVisible, setIsButtonVisible] = useState(true);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 1035) {
                setIsFilterVisible(true);
                setIsButtonVisible(false);
            } else {
                setIsFilterVisible(false);

                setIsButtonVisible(true);
            }
        };

        // Set initial visibility based on window size
        handleResize();

        // Add event listener for window resize
        window.addEventListener('resize', handleResize);

        // Cleanup event listener on component unmount
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const navigate = useNavigate();
    const { currentUser } = useAuth();

    const dateStyle = {
        width: {
            xs: '100%', // Full width on extra-small screens (mobile)
            sm: '300px', // 250px on small screens (tablets)
            md: '150px', // 300px on medium screens (desktop)
            lg: '210px', // 350px on large screens
        },
        '& .MuiInputLabel-root': {
            color: 'gray',
            '&.Mui-focused': {
                color: '#1F2933', // Color when focused
            },
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: '#82BD9C', // Default border color
            },
            '&:hover fieldset': {
                borderColor: '#299257', // Border color on hover
            },
            '&.Mui-focused fieldset': {
                borderColor: '#299257', // Border color when focused
            },
        },
    };


    const selectStyle = {
        // Default color
        '& .MuiSelect-select': {
            color: '#1F2933',
        },
        // Color when focused
        '&.Mui-focused .MuiSelect-select': {
            color: '#1F2933',
        },
        // Arrow color
        '& .MuiSelect-icon': {
            color: '#299257',
        },
        // Border color when focused
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#299257',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#299257',
        },
    }


    useEffect(() => {
        if (startDate && endDate) {
            getShoppingList();
        }
    }, [startDate, endDate]);

    async function getShoppingList() {
        const result = await get("/api/shopping-list/get_full_list",
            {
                user_id: currentUser.uid,
                start_date: startDate.format('YYYY-MM-DD'),
                end_date: endDate.format('YYYY-MM-DD'),
                country_code: 'US'
            })
        setShoppingList(result)

        // Extract distinct meal names
        const mealNamesSet = new Set(result.map(item => item.meal_name));

        // Convert Set to an array if needed
        let distinctMealNames = ['All Meals', ...Array.from(mealNamesSet)];
        setmealList(distinctMealNames)
    }

    function convertLocalDateToUTC(localDateString) {
        // Parse the local date string into a Date object
        const localDate = new Date(localDateString);
        // Extract the UTC date components
        const utcYear = localDate.getUTCFullYear();
        const utcMonth = (localDate.getUTCMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
        const utcDay = localDate.getUTCDate().toString().padStart(2, '0');

        // Return the UTC date string in 'YYYY-MM-DD' format
        return `${utcYear}-${utcMonth}-${utcDay}`;
    }

    const handleStartDateChange = (newValue) => {
        const newStartDate = dayjs(newValue);
        const end = dayjs(endDate);

        // If the new start date is after the current end date, adjust the end date
        if (newStartDate.isAfter(end)) {
            setEndDate(newStartDate);
        }
        setStartDate(newStartDate);
    };

    const handleEndDateChange = (newValue) => {
        const newEndDate = dayjs(newValue);
        const start = dayjs(startDate);

        // If the new end date is before the current start date, adjust the start date
        if (newEndDate.isBefore(start)) {
            setStartDate(newEndDate);
        }
        setEndDate(newEndDate);
    };

    function aggregateIngredients(ingredients) {
        const aggregated = new Map();

        ingredients.forEach(item => {
            const key = `${item.ingredient_name}-${item.unit_name}`;
            const amount = parseFloat(item.amount);

            if (aggregated.has(key)) {
                const existing = aggregated.get(key);
                existing.amount += amount;
                existing.ingredient_image = item.ingredient_image

                // Check if the meal name already exists
                const mealIndex = existing.meal_names.findIndex(meal => meal.name === item.meal_name);
                if (mealIndex === -1) {
                    // If not, push a new meal object
                    existing.meal_names.push({ name: item.meal_name, dates: [item.meal_date] }); // Store dates as an array
                } else {
                    // If it exists, add the date if it's not already there
                    if (!existing.meal_names[mealIndex].dates.includes(item.meal_date)) {
                        existing.meal_names[mealIndex].dates.push(item.meal_date);
                    }
                }
            } else {
                aggregated.set(key, {
                    ingredient_image: item.ingredient_image,
                    amount: amount,
                    meal_names: [{ name: item.meal_name, dates: [item.meal_date] }] // Store dates as an array
                });
            }
        });

        return Array.from(aggregated, ([key, value]) => {
            const [ingredient_name, unit_name] = key.split('-');
            return {
                ingredient_image: value.ingredient_image,
                ingredient_name,
                unit_name,
                amount: value.amount.toString(),
                meal_names: value.meal_names.map(meal => ({
                    name: meal.name,
                    dates: meal.dates // Keep dates as an array
                }))
            };
        });
    }



    function aggregateIngredientsByMeal(ingredients) {
        const meals = {};
        ingredients.forEach(item => {
            const mealKey = `${item.meal_name}-${item.meal_date}-${item.course}`;

            // Initialize the meal object if it doesn't exist
            if (!meals[mealKey]) {
                meals[mealKey] = {
                    meal_name: item.meal_name,
                    meal_id: item.meal_id,
                    meal_date: item.meal_date,
                    course: item.course,
                    total_cost: item.total_cost,
                    meal_image: item.meal_image,
                    ingredients: []
                };
            }

            const existing = meals[mealKey].ingredients.find(i => i.ingredient_name === item.ingredient_name && i.unit_name === item.unit_name);
            if (existing) {
                existing.amount += parseFloat(item.amount);
            } else {
                meals[mealKey].ingredients.push({
                    ingredient_name: item.ingredient_name,
                    ingredient_image: item.ingredient_image,
                    unit_name: item.unit_name,
                    amount: parseFloat(item.amount),
                });
            }
        });

        // Convert the meals object to an array of meal objects
        if (selectedMeal === 'All Meals') {
            return Object.values(meals);

        } else {
            return Object.values(meals).filter(meal => meal.meal_name === selectedMeal);
        }
    }

    function capitalizeWords(str) {
        return str
            .split(' ')             // Split the string into an array of words
            .map(word =>
                word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() // Capitalize first letter, make the rest lowercase
            )
            .join(' ');             // Join the array back into a string
    }


    return (
        <div className="shopping-list-container">

            <div className="shopping-list-header">

                {isFilterVisible && (

                    <div id='shopping-list-header-filter' className='shopping-list-header-filter'>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label="Start Date"
                                value={startDate}
                                onChange={setStartDate}
                                views={['year', 'month', 'day']}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: null,
                                        }}
                                    />
                                )}
                                sx={dateStyle}
                            />
                        </LocalizationProvider>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label="End Date"
                                value={endDate}
                                onChange={setEndDate}
                                views={['year', 'month', 'day']}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: null,
                                        }}
                                    />
                                )}
                                sx={dateStyle}
                            />
                        </LocalizationProvider>
                        <FormControl className='shopping-list-meals-select-form-control'>
                            <InputLabel
                                sx={{
                                    '&.Mui-focused': {
                                        color: '#1F2933',
                                    },
                                }}
                            >
                                {'Meals'}
                            </InputLabel>
                            <Select
                                label={'Meals'}
                                value={selectedMeal}
                                onChange={(e) => {
                                    let meal_name = e.target.value;
                                    if (meal_name !== 'All Meals') {
                                        setViewMode('meal_based');
                                    }
                                    setSelectedMeal(meal_name);
                                }}
                                sx={selectStyle}
                            >
                                {meals_list.map((mealName) => (
                                    <MenuItem key={mealName} value={mealName}>{mealName}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                    </div>
                )}
                {/* {
                    isButtonVisible && isFilterVisible && <hr color='#82BD9C' />

                } */}

                <div className='shopping-list-viewmode-parent'>
                    <FormControl className='shopping-list-viewMode-select-form-control'>
                        <InputLabel
                            sx={{
                                '&.Mui-focused': {
                                    color: '#1F2933',
                                },
                            }}
                        >
                            {'View Mode'}
                        </InputLabel>
                        <Select
                            label={'View Mode'}
                            value={viewMode}
                            onChange={(e) => {
                                let view_mode = e.target.value;
                                setViewMode(view_mode);
                                if (view_mode !== 'meal_based') {
                                    setSelectedMeal('All Meals');
                                }
                            }}
                            sx={selectStyle}
                        >
                            <MenuItem value={'ingredient_based'}>{'Ingredient Based'}</MenuItem>
                            <MenuItem value={'meal_based'}>{'Meal Based'}</MenuItem>
                        </Select>
                    </FormControl>

                    {isButtonVisible && (

                        <p className='font_family_inter green_gradient_p shopping-list-viewmode-filter-button'
                            style={{ margin: '0px' }}
                            onClick={() => setIsFilterVisible(!isFilterVisible)}>
                            {isFilterVisible ? 'Hide Filters' : 'Filters'}
                        </p>
                    )}
                </div>

            </div>

            {
                shoppingList.length > 0 ? (
                    viewMode === 'ingredient_based' ? (
                        <div className="shopping-list-items-container">
                            {
                                aggregateIngredients(shoppingList).map(item => (
                                    <div key={item.ingredient_name + item.unit_name} className="shopping-list-ingredient-based-ingredient gray_scale_1">
                                        <img src={item.ingredient_image} className='' />
                                        <p className='font_family_ovo font_size_16 font_weight_600 '>{capitalizeWords(item.ingredient_name)}</p>
                                        <p className='font_family_inter font_size_14 '>{item.amount ? `${item.amount} ${item.unit_name || ""}` : "Not Provided."}</p>
                                        <div className='shopping-list-ingrefient-based-hover-tooltip '>
                                            {item.meal_names.length === 1 ? (
                                                <p className="meal-item">{item.meal_names[0].name}</p>
                                            ) : (
                                                <p style={{ cursor: 'pointer' }}>
                                                    {`${item.meal_names.length} meals`}
                                                    <span title={item.meal_names.map(meal => meal.name).join(', ')}>
                                                        {/* Tooltip on hover */}
                                                    </span>
                                                </p>
                                            )}
                                        </div>

                                    </div>

                                ))
                            }
                        </div>
                    ) : (
                        <div className='shopping-list-meal-list-parent'>
                            {
                                aggregateIngredientsByMeal(shoppingList).map(meal => (
                                    <div key={meal.meal_name + meal.meal_date} className='shopping-list-meal-container'>
                                        <p className='font_family_ovo font_size_30'
                                            style={{ cursor: 'pointer', width: 'fit-content' }}
                                            onClick={
                                                () => {
                                                    navigate(`/meal-details/${meal.meal_id}`);
                                                    window.scrollTo({
                                                        top: 0,
                                                        behavior: 'smooth' // Optional: adds smooth scrolling animation
                                                    })
                                                }
                                            }
                                        >{capitalizeWords(meal.meal_name)}</p>
                                        <div className="shopping-list-meal-wo-title">

                                            <img src={meal.meal_image} className='shopping-list-meal-based-meal-image' />

                                            <div className='shopping-list-meal-based-meal_main'>

                                                <div className='shopping-list-meal-based-meal_main_info'>
                                                    <div className='flex flex_wrap justify_space_around gap_20'>
                                                        <span className='flex gap_6'>
                                                            <p className='font_family_inter font_size_16'>Course: </p>
                                                            <p className='gray_scale_2 font_family_inter font_size_16'>{capitalizeWords(meal.course)}</p>
                                                        </span>
                                                        <span className='flex gap_6'>
                                                            <p className='font_family_inter font_size_16'>Date: </p>
                                                            <p className='gray_scale_2 font_family_inter font_size_16'>{meal.meal_date}</p>
                                                        </span>
                                                        <span className='flex gap_6'>
                                                            <p className='font_family_inter font_size_16'>Cost: </p>
                                                            <p className='gray_scale_2 font_family_inter font_size_16'>{meal.total_cost}</p>
                                                        </span>
                                                    </div>
                                                    <div className="shopping-list-meal-ingredients">
                                                        {meal.ingredients.map(item => (
                                                            <div key={item.ingredient_name + item.unit_name} className="shopping-list-meal-based-ingredient gray_scale_1">
                                                                <img src={item.ingredient_image} />
                                                                <p className='font_family_ovo font_size_16 font_weight_600 gray_scale_1'>{capitalizeWords(item.ingredient_name)}</p>
                                                                <p className='font_family_inter font_size_14 gray_scale_1'>{item.amount ? `${item.amount} ${item.unit_name || ""}` : "Not provided."}</p>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                ))
                            }
                        </div>
                    )
                ) : (
                    <div>
                        <p className="shopping-list-no-items-text">No items to show</p>
                    </div>
                )
            }
            <br />
        </div >


    );
}

export default ShoppingList;
